module.exports = __webpack_public_path__ + "img/thanks.d9c12dd0.png";